import React from 'react';
import { createNotificationPanelClassName } from './notificationPanelStyles';

type Intent = 'neutral' | 'critical' | 'warning';

type Props = {
  intent: Intent;
  text: React.ReactNode;
  primaryAction: React.ReactNode;
  secondaryAction: React.ReactNode;
};

export const NotificationPanelComponent: React.FC<Props> = (props) => {
  const { intent, text, primaryAction, secondaryAction } = props;

  const className = createNotificationPanelClassName('wrapper', {
    intent,
  });

  return (
    <div className={className}>
      <div className={createNotificationPanelClassName('text')}>{text}</div>
      <div
        className={createNotificationPanelClassName('actions', {
          intent,
        })}
      >
        {primaryAction}
        {secondaryAction}
      </div>
    </div>
  );
};
